<script setup lang="ts"></script>
<template>
  <div role="button" v-bind="$attrs">
    <a class="nav-link" target="blank">Feedback</a>
  </div>
</template>

<style scoped>
.nav-link {
  color: var(--bs-gray-500);
  transition: all 0.3s ease;
  &:focus,
  &:hover {
    color: var(--bs-gray-100);
  }
}
@media (max-width: 767px) {
  .nav-link {
    display: none;
  }
}
</style>
